module.exports = __webpack_public_path__ + "media/images/vp/parallax.new.04.c-1100a4050307aa4daa468f59831002ab.svg";